import Input from "../../../utils/components/Input";
import SelectBox from "../../../utils/components/SelectBox";

const statusCustomStyles = {
  option: (provided, state) => {
    const status = state.data;

    if (status.value === "draft") return { ...provided, color: "#0092ff" };
    else if (status.value === "published")
      return { ...provided, color: "#68b800" };
    else if (status.value === "inactive")
      return { ...provided, color: "#fa6400" };
    else return provided;
  },
};

const FormDetailEdit = ({
  formDetails,
  setFormDetails,
  isNew,
  translate,
  locationSets,
  revisionSets,
  statusSets,
}) => {
  return (
    <div className="GeneralInfoEdit">
      <div className="container">
        <div className="row ps-md-3 py-4">
          <div className="col-12 col-md-5 mb-4">
            <p className="text-uppercase mb-2 fw-bold">
              {translate(
                "form_templates.uppercase_translates.general_info.status"
              )}
            </p>
            <SelectBox
              options={[
                { value: "draft", label: translate("draft") },
                { value: "inactive", label: translate("inactive") },
                { value: "published", label: translate("published") },
              ]}
              value={
                formDetails?.status
                  ? {
                      value: formDetails.status.value,
                      label: translate(formDetails.status.value),
                    }
                  : null
              }
              onChange={(status) => {
                setFormDetails({ ...formDetails, status });
              }}
              customStyles={statusCustomStyles}
              height="36px"
            />
          </div>
          {!isNew && (
            <div className="col-12 col-md-5 mb-4">
              <div className="w-100">
                <Input
                  type="text"
                  disabled
                  value={formDetails?.created_at || ""}
                  title={translate(
                    "form_templates.uppercase_translates.general_info.created_at"
                  )}
                />
              </div>
            </div>
          )}
          {!isNew && (
            <div className="col-12 col-md-5 mb-4">
              <div className="w-100">
                <Input
                  type="text"
                  disabled
                  value={formDetails?.version || ""}
                  title={translate(
                    "form_templates.uppercase_translates.general_info.version"
                  )}
                />
              </div>
            </div>
          )}
          {!isNew && (
            <div className="col-12 col-md-5 mb-4">
              <div className="w-100">
                <Input
                  type="text"
                  disabled
                  value={formDetails?.created_by}
                  onChange={(e) => {
                    setFormDetails({
                      ...formDetails,
                      created_by: e.target.value,
                    });
                  }}
                  title={translate(
                    "form_templates.uppercase_translates.general_info.created_by"
                  )}
                />
              </div>
            </div>
          )}
          <div className="col-12 col-md-5 mb-4">
            <div className="w-100">
              <Input
                type="text"
                value={formDetails?.id_number || ""}
                onChange={(e) => {
                  setFormDetails({ ...formDetails, id_number: e.target.value });
                }}
                title={translate(
                  "form_templates.uppercase_translates.general_info.id_number"
                )}
              />
            </div>
          </div>
          {!isNew && (
            <div className="col-12 col-md-5 mb-4">
              <div className="w-100">
                <Input
                  type="text"
                  disabled
                  value={formDetails?.modified_at ? "" : ""}
                  title={translate(
                    "form_templates.uppercase_translates.general_info.updated_at"
                  )}
                />
              </div>
            </div>
          )}
          <div className="col-12 col-md-5 mb-4">
            <div className="w-100">
              <Input
                type="text"
                value={formDetails?.name || ""}
                onChange={(e) => {
                  setFormDetails({ ...formDetails, name: e.target.value });
                }}
                title={translate(
                  "form_templates.uppercase_translates.general_info.form_name"
                )}
              />
            </div>
          </div>
          {!isNew && (
            <div className="col-12 col-md-5 mb-4">
              <div className="w-100">
                <Input
                  type="text"
                  disabled
                  value={formDetails?.modified_by || ""}
                  title={translate(
                    "form_templates.uppercase_translates.general_info.updated_by"
                  )}
                />
              </div>
            </div>
          )}
          <div className="col-12 col-md-5 mb-4">
            <p className="text-uppercase mb-2 fw-bold">
              {translate(
                "form_templates.uppercase_translates.general_info.location_set"
              )}
            </p>
            <SelectBox
              options={locationSets}
              value={formDetails?.site_set || null}
              onChange={(site_set) => {
                setFormDetails({
                  ...formDetails,
                  site_set,
                  site_set_level: null,
                });
              }}
              height="36px"
            />
          </div>
          <div className="col-12 col-md-5 mb-4">
            <p className="text-uppercase mb-2 fw-bold">
              {translate(
                "form_templates.uppercase_translates.general_info.location_set_level"
              )}
            </p>
            <SelectBox
              options={
                formDetails?.site_set
                  ? Array.from(
                      { length: formDetails.site_set.level },
                      (_, i) => ({
                        value: String(i + 1),
                        label: `${translate("level")} ${i + 1}`,
                      })
                    )
                  : []
              }
              value={formDetails?.site_set_level || null}
              onChange={(site_set_level) => {
                setFormDetails({ ...formDetails, site_set_level });
              }}
              height="36px"
            />
          </div>
          <div className="col-12 col-md-5 mb-4">
            <p className="text-uppercase mb-2 fw-bold">
              {translate(
                "form_templates.uppercase_translates.general_info.status_set"
              )}
            </p>
            <SelectBox
              options={statusSets}
              value={formDetails?.status_set || null}
              onChange={(status_set) => {
                setFormDetails({ ...formDetails, status_set });
              }}
              height="36px"
            />
          </div>
          <div className="col-12 col-md-5 mb-4">
            <p className="text-uppercase mb-2 fw-bold">
              {translate(
                "form_templates.uppercase_translates.general_info.revision_set"
              )}
            </p>
            <SelectBox
              options={revisionSets}
              value={formDetails?.revision_set || null}
              onChange={(revision_set) => {
                setFormDetails({ ...formDetails, revision_set });
              }}
              height="36px"
            />
          </div>
          <div className="col-12 col-md-5 mb-4">
            <div className="w-100">
              <Input
                type="text"
                value={formDetails?.prefix || ""}
                onChange={(e) => {
                  setFormDetails({ ...formDetails, prefix: e.target.value });
                }}
                title={translate(
                  "form_templates.uppercase_translates.general_info.prefix"
                )}
              />
            </div>
          </div>
          <div className="col-12 col-md-5 mb-4">
            <div className="w-100">
              <Input
                type="text"
                className="fw-bold"
                value={formDetails?.counter_format || ""}
                onChange={(e) => {
                  setFormDetails({
                    ...formDetails,
                    counter_format: e.target.value.replace(/[^0]/g, "") + "X",
                  });
                }}
                title={translate(
                  "form_templates.uppercase_translates.general_info.counter_format"
                )}
                inputProps={{
                  onFocus: (e) => e.target.select(),
                }}
              />
            </div>
          </div>
          <div className="col-12 col-md-5 mb-4">
            <p className="text-uppercase mb-2 fw-bold">
              {translate(
                "form_templates.uppercase_translates.general_info.quick_start"
              )}
            </p>
            <SelectBox
              options={[
                { label: translate("yes"), value: true },
                { label: translate("no"), value: false },
              ]}
              value={formDetails?.quick_start || null}
              onChange={(quick_start) => {
                setFormDetails({ ...formDetails, quick_start });
              }}
              height="36px"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default FormDetailEdit;
